import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MasterService {

  // apiUrl = environment.API_URL ;
  apiUrl2 = environment.API_URL2 ;

  constructor(private http : HttpClient) { }


//   getAllChBatch(){
//     return this.http.get(`${this.apiUrl}/`);
//   }

// //get all charger serial no filtered on batch ID
//   getChSrNo(params){
//     return this.http.post(`${this.apiUrl}/Charger/GetSerial`,params);
//   }

  getBrands(){
    return this.http.get(`${this.apiUrl2}/brands`);
  }

  getVehicleTypes(){
    ////
    return this.http.get(`${this.apiUrl2}/vehicleTypes`);
  }

  getModelsByBrand(id){
    return this.http.get(`${this.apiUrl2}/vehicleModels/${id}`);
  }
  getConnectorTypeByModel(id){
    return this.http.get(`${this.apiUrl2}/connectorTypes/${id}`);
  }
  getPublishedConnectorTypeByModel(id){
    return this.http.get(`${this.apiUrl2}/connectorTypesPublished/${id}`);
  }

  getConnectorTypes(){
    // Old APi naming convention with connectorTypes
    // return this.http.get(`${this.apiUrl2}/connectorTypes`);

    // Old APi naming convention with connectorTyp
    return this.http.get(`${this.apiUrl2}/connectorTypes`);
  }

  connectorTypesExcludingVModelId(id){
    //
    return this.http.get(`${this.apiUrl2}/connectorTypesExcludingVModelId/${id}`);
  }
  getAllCTypesExcludingOtherAlreadyMapped(vm_id,ct_id){
    //
    return this.http.get(`${this.apiUrl2}/gtAllCTypesExcludingOtherAlreadyMapped/${vm_id}/${ct_id}`);
  }

  getManufacturers(){
    return this.http.get(`${this.apiUrl2}/manufacturer/getManufacturers`);
  }
  getChargerModelTypes(){
    return this.http.get(`${this.apiUrl2}/charger_model_type/getChargerModelTypes`);
  }
  getCommunicationProtocols(){
    return this.http.get(`${this.apiUrl2}/communication_protocol/getCommunicationProtocols`);
  }

  getCurrentTypes(){
    return this.http.get(`${this.apiUrl2}/currentType/gtCurrentTypes`);
  }
  getIOTypes(){
    return this.http.get(`${this.apiUrl2}/io_type/getIOTypes`);
  }



}
